export const HasOneOfRights = (compareAgainstRights, userRights) => compareAgainstRights
    .map((requiredRight) => userRights.find((right) => right.Name === requiredRight))
    .filter(x => x !== undefined).length > 0;

export const HasAllRights = (compareAgainstRights, userRights) => compareAgainstRights
    .map((requiredRight) => userRights.find((right) => right.Name === requiredRight))
    .filter(x => x !== undefined).length === compareAgainstRights.length;